/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { Modal } from "./Modal";
import { ButtonPrimary } from "./NewButtons";
import { ModalProps } from "antd";

const buttonWrapper = css`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: end;
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  confirmButton: React.ReactNode;
  title: string;
  subtitle?: string;
  cancelButtonText?: string;
} & ModalProps;

export const ConfirmActionModal = ({
  isOpen,
  onClose,
  children,
  confirmButton,
  title,
  subtitle,
  width,
  cancelButtonText = "Cancel",
  ...rest
}: Props) => {
  return (
    <Modal
      header={title}
      subtitle={subtitle}
      isOpen={isOpen}
      onClose={onClose}
      width={width}
      {...rest}
    >
      {children}
      <div css={buttonWrapper}>
        <ButtonPrimary onClick={() => onClose()} type="button">
          {cancelButtonText}
        </ButtonPrimary>
        {confirmButton}
      </div>
    </Modal>
  );
};
